export const RANGER_AVATAR = "https://static.prod-images.emergentagent.com/jobs/aa1495be-2be9-4669-b2d1-d5e4a9831348/images/ef38712c69ac7086d7077706fe161f12b74209c0947c2f089ab0225aa205f034.jpeg";
export const HERO_MURAL = "https://static.prod-images.emergentagent.com/jobs/aa1495be-2be9-4669-b2d1-d5e4a9831348/images/f5c799719e93a395fa54ed1753530d50156c290a8635e4b414ec1dde8233e4a5.jpeg";

export const NAV_LINKS = [
  { to: "/directory", label: "Directory" },
  { to: "/events", label: "Events" },
  { to: "/promotions", label: "Promotions" },
  { to: "/tours", label: "Tours" },
  { to: "/guides", label: "Guides" },
  { to: "/contest", label: "Photo Contest" },
  { to: "/about", label: "About" },
];

export const SUBNAV = [
  { to: "/directory", label: "Explore RiNo" },
  { to: "/explore/food-drink", label: "Food & Drink" },
  { to: "/explore/bars", label: "Bars & Nightlife" },
  { to: "/explore/coffee", label: "Coffee" },
  { to: "/explore/shopping", label: "Shopping" },
  { to: "/explore/art-culture", label: "Art & Culture" },
  { to: "/explore/stay", label: "Stay" },
  { to: "/offers", label: "Deals", deal: true },
];

// Customer subscription options
export const SUB_TOPICS = [
  { key: "events_weekly", label: "Upcoming Events digest", desc: "A weekly roundup of what's happening in RiNo" },
  { key: "deals", label: "New Deals & Offers", desc: "Fresh happy hours and specials as they drop" },
  { key: "newsletter", label: "The RiNo Newsletter", desc: "District news, features, and stories" },
];

export const SUB_GENRES = [
  { key: "live-music", label: "Live Music" },
  { key: "jazz", label: "Jazz" },
  { key: "hip-hop", label: "Hip-Hop" },
  { key: "electronic", label: "Electronic / DJ" },
  { key: "indie-rock", label: "Indie & Rock" },
  { key: "comedy", label: "Comedy" },
];

export const SUB_INTERESTS = [
  { key: "wine", label: "Wine" },
  { key: "beer", label: "Beer & Breweries" },
  { key: "coffee", label: "Coffee" },
  { key: "food", label: "Food & Dining" },
  { key: "art", label: "Art & Galleries" },
  { key: "cocktails", label: "Cocktails" },
  { key: "markets", label: "Markets & Pop-ups" },
];

export const FREQ_OPTIONS = [
  { value: "instant", label: "Instantly" },
  { value: "daily", label: "Daily digest" },
  { value: "weekly", label: "Weekly digest" },
  { value: "off", label: "Off" },
];

export const SECTION_MAP = {
  "food-drink": { type: "category", value: "Places to Eat + Drink", title: "Food & Drink" },
  "bars": { type: "category", value: "Bars + Breweries", title: "Bars & Nightlife" },
  "shopping": { type: "category", value: "Specialty Shops + Salons", title: "Shopping" },
  "art-culture": { type: "category", value: "Galleries + Studios", title: "Art & Culture" },
  "stay": { type: "category", value: "Hotels + Stays", title: "Where to Stay" },
  "coffee": { type: "tags", value: ["coffee", "cafe"], title: "Coffee & Cafes" },
  "nightlife": { type: "tags", value: ["brewery", "bar", "rooftop", "nightlife", "trivia", "margaritas"], title: "Nightlife" },
};

// Rich category hub landing pages (venues + guides + deals + events + tours)
export const EXPLORE_SECTIONS = {
  "food-drink": {
    overline: "Eat & Drink", title: "Food & Drink in RiNo",
    subtitle: "From chef-driven tasting menus and food-hall stalls to street tacos and late-night bites — the most complete guide to eating well in the River North Art District.",
    business: { type: "category", value: "Places to Eat + Drink" },
    guideTags: ["restaurants", "food", "dining", "coffee", "cafe"],
    guideSlugs: ["where-to-eat-in-rino", "best-coffee-shops-in-rino"],
    offerCats: ["Food & Drink", "Coffee"],
  },
  "bars": {
    overline: "Bars & Nightlife", title: "Bars, Breweries & Nightlife",
    subtitle: "RiNo turned warehouses into Denver's beer heart. Hazy IPAs, barrel-aged sours, cocktail rooms, and late-night energy — here's where the district drinks.",
    business: { type: "category", value: "Bars + Breweries" },
    guideTags: ["breweries", "bars", "beer", "nightlife"],
    guideSlugs: ["best-breweries-bars-in-rino"],
    offerCats: ["Food & Drink"],
  },
  "coffee": {
    overline: "Caffeinate", title: "Coffee & Cafes in RiNo",
    subtitle: "Third-wave roasters, all-day cafes, and the unofficial morning offices of RiNo's creative class.",
    business: { type: "tags", value: ["coffee", "cafe"] },
    guideTags: ["coffee", "cafe", "breakfast"],
    guideSlugs: ["best-coffee-shops-in-rino"],
    offerCats: ["Coffee"],
  },
  "shopping": {
    overline: "Shop Local", title: "Shopping in RiNo",
    subtitle: "Independent boutiques, maker goods, vintage, salons, and design shops — where to shop local in Denver's most creative neighborhood.",
    business: { type: "category", value: "Specialty Shops + Salons" },
    guideTags: ["shopping", "boutiques", "local"],
    guideSlugs: ["best-shopping-in-rino"],
    offerCats: ["Shopping"],
  },
  "art-culture": {
    overline: "Art & Culture", title: "Art & Culture in RiNo",
    subtitle: "Galleries, working studios, murals, and First Fridays — the reason RiNo is Denver's Art District.",
    business: { type: "category", value: "Galleries + Studios" },
    guideTags: ["galleries", "art", "first-fridays", "murals", "street art"],
    guideSlugs: ["best-art-galleries-studios-in-rino"],
    offerCats: [],
  },
  "stay": {
    overline: "Stay Awhile", title: "Where to Stay in RiNo",
    subtitle: "Wake up inside the art district. RiNo's concept and boutique hotels put you steps from the murals, breweries, and galleries.",
    business: { type: "category", value: "Hotels + Stays" },
    guideTags: ["hotels", "stay", "travel"],
    guideSlugs: ["where-to-stay-in-rino"],
    offerCats: [],
  },
};
